module.exports = __webpack_public_path__ + "img/モメ度診断.fc9b2199.png";